

const values = [
  {
    icon: "ri-shield-user-line",
    title: "Security First",
    desc: "Every product is built with user privacy and data security as the top priority.",
  },
  {
    icon: "ri-palette-line",
    title: "Refined Design",
    desc: "We obsess over every pixel to deliver interfaces that feel native and intuitive.",
  },
  {
    icon: "ri-rocket-2-line",
    title: "Performance",
    desc: "Optimized for iOS to run smoothly without draining battery or resources.",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "User-Centric",
    desc: "Real feedback from real users shapes every update and new feature we ship.",
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="py-28" style={{ background: "#FFF9F0" }}>
      <div className="max-w-7xl mx-auto px-6">
        {/* Top label */}
        <span className="text-xs uppercase tracking-[0.25em] text-[#b08060] font-medium">/ About Us</span>

        <div className="mt-8 flex flex-col lg:flex-row gap-16 items-start">
          {/* Left: Text */}
          <div className="flex-1">
            <h2 className="text-4xl md:text-5xl font-thin text-[#3D2817] leading-[1.3] mb-6">
              A dedicated team<br />
              <span className="font-light">crafting iOS experiences</span><br />
              <span className="font-light text-[#b08060]">that truly matter.</span>
            </h2>
            <p className="text-[#7a5c44] text-base leading-relaxed font-light mb-4">
              BOBIS d.o.o. was founded with a singular mission: to build iOS applications that genuinely improve people&apos;s digital lives. Our team brings together deep expertise in mobile development, UX design, and cybersecurity.
            </p>
            <p className="text-[#7a5c44] text-base leading-relaxed font-light">
              Based in Croatia, we operate as a lean, focused studio. We believe that great software comes from small, passionate teams who care deeply about the craft — not from large corporations shipping features for the sake of it. Every line of code we write is intentional.
            </p>


          </div>

          {/* Right: Image + Values */}
          <div className="flex-1 flex flex-col gap-6">
            <div className="rounded-3xl overflow-hidden w-full h-64 md:h-80">
              <img
                src="https://public.readdy.ai/ai/img_res/0645ce4f366c7b63832da3e68ae44328.jpg"
                alt="BOBIS d.o.o. Team"
                className="w-full h-full object-cover object-top"
              />
            </div>

            {/* Values grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {values.map((v) => (
                <div
                  key={v.title}
                  className="bg-white/70 rounded-2xl p-5 border border-[#f0e0d0] hover:bg-white transition-colors duration-200"
                >
                  <div className="w-9 h-9 flex items-center justify-center rounded-xl mb-3" style={{ background: "#fde8d0" }}>
                    <i className={`${v.icon} text-[#b08060] text-lg`} />
                  </div>
                  <h4 className="text-sm font-semibold text-[#3D2817] mb-1">{v.title}</h4>
                  <p className="text-xs text-[#9a7a64] leading-relaxed font-light">{v.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
